import React, { useState, useEffect } from "react";
import { Table, Pagination, Spin, Divider, Modal } from "antd";
import axios from "axios";
import reportServices from "../../services/pollination-report-service";
import pollinationService from "../../services/pollination-service";
import { es } from "date-fns/locale/es";
import { useForm } from "react-hook-form";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import lineService from "../../services/line-service";
import moment from "moment";
import config from "../../config/config";
import sectionService from "../../services/section-service";
import userService from "../../services/user-service";
import { ToastContainer, toast } from 'react-toastify';
import Swal from "sweetalert2";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import DatePicker from "react-datepicker";

const UpdateRecord = () => {

  registerLocale("es", es);
  const start_date = moment().add(-config.DAYS_LESS_MAP, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listLines, setListLines] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);
  const [isModalOpen, setIsModalOpen] = useState(false);
  ///Aplicaciones por dia
  const [initReport, setInitReport] = useState(false);  

  const [idMovement, setIdMovement] = useState("");
  const [lineName, setLineName] = useState("");
  const [palmName, setPalmName] = useState("");


  const [farmId, setFarmId] = useState("0");
  const [sectionId, setSectionId] = useState("0");
  const [lotId, setLotId] = useState("0");


  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);



  const [loadingLots, setLoadingLots] = useState(false);
  const [loadingLines, setLoadingLines] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);




  const getListFilterUsers = async () => {
    setValue("user", "0")
    const userId = "0"
    try {
      setLoadingUsers(true)
      let start = moment(endDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      const response = await userService.listInAccumulation(start, end, farmId, sectionId, lotId)
      const listado = response.data
      if (listado) {
        listado.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }
    setLoadingUsers(false)
  }


  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
    }
  };

  const getListSection = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListSection(escoja);
      setListLots(escoja);
      setValue("section", "0")
      setValue("lot", "0")
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
      setValue("section", "0")
      setValue("lot", "0")
      setValue("line", "0")
      setValue("user", "0")
    }
  };



  const getLisLots = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListLots(escoja);
      setValue("lot", "0")
      setValue("line", "0")
      setValue("user", "0")
      return;
    }
    setLoadingLots(true)
    setLoadingUsers(true)
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      setValue("lot", "0")
      setValue("line", "0")
      setValue("user", "0")
    }
    setLoadingLots(false)
    setLoadingUsers(false)
  };

  const getListLines = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListLines(escoja);
      return;
    }
    setLoadingLines(true)
    setLoadingUsers(true)
    let listado = await lineService.getList(code);
    listado.unshift({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedList = [...listado].sort((a, b) => {
        const numA = parseInt(a.name);
        const numB = parseInt(b.name);
        return numA - numB;
      });
      setListLines(sortedList);
      setValue("line", "0")
      setValue("user", "0")
    }
    setLoadingLines(false)
    setLoadingUsers(false)
  };




  const searchMovements = async (pageSize) => {
    setInitReport(true)
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const lineId = getValues("line")
      const params = { page, limit: pageSize, startDate: end, endDate: end, farmId, sectionId, lotId, userId, lineId }
      const response = await reportServices.detailedReport(params);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchMovements = async (page, pageSize) => {
    if (!initReport) return;
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const lineId = getValues("line")
      const params = { page, limit: pageSize, startDate: end, endDate: end, farmId, sectionId, lotId, userId, lineId }
      const response = await reportServices.detailedReport(params);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  };


  const getMovement = async (idMovement, line_name, palm_name, firstApplication,secondApplication,thirdApplication) => {
    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios de edición.', { autoClose: 1000 });
      return;
    }
    setIdMovement(idMovement)
    setLineName(line_name)
    setPalmName(palm_name)
    setValue("new_line", line_name)
    setValue("new_palm", palm_name)
    setValue("new_first", firstApplication)
    setValue("new_second", secondApplication)
    setValue("new_third", thirdApplication)
    setIsModalOpen(true);
  }


  const deleteMovement = async (id, operator, line, palm) => {
    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios de edición.', { autoClose: 1000 });
      return;
    }
    else {
      Swal.fire({
        title: `Eliminar registro`,
        html: `Desea eliminar el registro de ${operator}<br/>Linea ${line} Palma ${palm}?`,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Eliminar registro",
        denyButtonText: `Conservar`
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = { id };
          const success = await pollinationService.deleteMovement(data);
          if (success) {
            fetchMovements(1, pageSize)
            toast('Realizado.', { autoClose: 1000 });
          }
        }
      });
    }
  }


  const getNameApplication = (code) => {
    switch (code) {
      case 1:
        return "Primera";
      case 2:
        return "Segunda";
      case 3:
        return "Tercera";
      case 0:
        return "Sin Aplicación";
      default:
        return "Desconocido";
    }
  };




  const updateQuantities = async () => {
    setLoadingSave(true)
    const new_first = getValues("new_first")
    const new_second = getValues("new_second")
    const new_third = getValues("new_third")
    console.log("salvando idMovement:", idMovement)
    const data = { id: idMovement,new_first,new_second,new_third};    
    const success = await pollinationService.updateQuantities(data);
    if (success) {
      searchMovements(10)
      setIsModalOpen(false)
      toast('Realizado.', { autoClose: 1000 });
    }
    setLoadingSave(false)
  }





  const saveChanges = async () => {
    setLoadingSave(true)
    const new_line = getValues("new_line")
    const new_palm = getValues("new_palm")
    const new_quantity = getValues("new_quantity")
    console.log("salvando idMovement:", idMovement)
    console.log("salvando newLineName:", new_line)
    console.log("salvando newPalmName:", new_palm)
    const data = { id: idMovement, newLine: new_line, newPalm: new_palm};  
    const success = await pollinationService.updateLinePalm(data);
    if (success) {
      searchMovements(10)
      setIsModalOpen(false)
      toast('Realizado.', { autoClose: 1000 });
    }
    setLoadingSave(false)
  }



  const saveAllLine = async () => {
    setLoadingSave(true);
    try {
      // Ejecutar uno tras otro
      for (const item of data) {
        const id = item.idMovement;
        const new_palm = item.palmName;
        const new_line = getValues("new_line");
        console.log(`se actualizará el registro ${id}, de la palma ${new_palm} a la linea: ${new_line}`);
        const dataToSend = { id, newLine: new_line, newPalm: new_palm};  
        const success = await pollinationService.updateLinePalm(dataToSend);
        toast('Realizado.', { autoClose: 100 });
      }
      setIsModalOpen(false);
      await searchMovements(10);
    } catch (error) {
      console.error('Error al guardar:', error);
      toast('Error al guardar algunos registros', { autoClose: 100 });
    } finally {
      setLoadingSave(false);
    }
  };










  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "date",
      key: "date",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Usuario",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Finca",
      dataIndex: "farmName",
      key: "farmName",
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
    },
    // Agrega más columnas según sea necesario
  ];



  const fomatDateHour = (dateMongo) => {
    return new Date(dateMongo).toLocaleString("es-CO", {
      timeZone: "America/Bogota",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).replace(",", "");;
  }


  useEffect(() => {
    getListFilterUsers()
  }, [endDate, farmId, sectionId, lotId]);


  useEffect(() => {
    getLisFarm();
  }, []);

  useEffect(() => {
    fetchMovements(page, pageSize);
  }, [page, pageSize]);

  return (
    <div className="row p-4">
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Edición de registros</Divider>
      </div>

      <div className="col-12">
        <form className="form-react">
          <div className="row mb-3">
            <div className="col-12 col-sm-10">
              <div className="row">



                <div className=" col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Finca</label>
                  <select
                    className="form-control text-secondary"
                    {...register("farm")}
                    onChange={(e) => {
                      getListSection(e)
                      const value = e.target.value
                      setFarmId(value)
                    }
                    }
                  >
                    {listFarms.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>



                <div className=" col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Sección</label>
                  <select
                    className="form-control text-secondary"
                    {...register("section")}
                    onChange={(e) => {
                      getLisLots(e)
                      const value = e.target.value
                      setSectionId(value)
                    }
                    }
                  >
                    {listSection.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className=" col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Lote</label>
                  <Spin spinning={loadingLots}>
                    <select
                      className="form-control text-secondary"
                      {...register("lot")}
                      onChange={
                        (e) => {
                          getListLines(e)
                          const value = e.target.value
                          setLotId(value)
                        }
                      }
                    >
                      {listLots.map((option) => (
                        <option key={option._id} value={option._id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </Spin>
                </div>


                <div className=" col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Linea</label>
                  <Spin spinning={loadingLines}>
                    <select
                      className="form-control text-secondary"
                      {...register("line")}
                      onChange={(e) => {
                        const value = e.target.value;
                        //setValue("user", "0")
                      }}
                    >
                      {listLines.map((option) => (
                        <option key={option._id} value={option._id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </Spin>
                </div>

                <div className=" col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Usuario</label>
                  <Spin spinning={loadingUsers}>
                    <select
                      className="form-control text-secondary"
                      {...register("user")}
                      onChange={(e) => {
                        const value = e.target.value;
                      }}
                    >
                      {listUsers.map((option) => (
                        <option key={option._id} value={option._id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </Spin>
                </div>



                <div className="col-6 col-sm-2">
                  <label className="text-secondary fw-bold">Fecha</label>
                  <br />
                  <DatePicker
                    locale="es"
                    dateFormat="yyyy-MM-dd"
                    className="form-control 
                              text-secondary"
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                  />
                </div>
              </div>
            </div>


            <div className="col-12 col-sm-2">

              <div className=" col-12">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}>
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => searchMovements(pageSize)}
                  >
                    <i className="bi bi-search fa-lg m-2" /> Buscar
                  </button>
                </Spin>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Pagination
        className="text-primary "
        current={page}
        pageSize={pageSize}
        total={total}
        onChange={handlePageChange}
        pageSizeOptions={["10", "20", "50"]}
        showTotal={(total) => `Total ${total} registros`}
        showSizeChanger
        onShowSizeChange={(current, size) => handlePageChange(1, size)}
      />
      <Spin spinning={loading}>
        <div className="card mt-3" style={{ minHeight: "400px" }}>

          <div className="table-responsive">
            <table className="table">
              <thead className="table-primary">
                <tr>
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>Finca</th>
                  <th>Seccion</th>
                  <th>Lote</th>
                  <th>Línea</th>
                  <th>Palma</th>
                  <th>1ra</th>
                  <th>2da</th>
                  <th>3ra</th>
                  <th>Total</th>
                  <th>Editar</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {

                  const nameApplication = getNameApplication(item.applicationType)

                  return (
                    <tr key={index}>
                      <td width="100px" >{fomatDateHour(item.date)
                      }</td>
                      <td>{item.userName}</td>
                      <td>{item.farmName}</td>
                      <td>{item.sectionName}</td>
                      <td>{item.lotName}</td>
                      <td>{item.lineName}</td>
                      <td>{item.palmName}</td>
                      <td>{item.firstApplication}</td>
                      <td>{item.secondApplication}</td>
                      <td>{item.thirdApplication}</td>
                      <td>{item.totalApplications}</td>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => getMovement(item.idMovement, item.lineName, item.palmName, item.firstApplication, item.secondApplication, item.thirdApplication)}
                        >
                          <i className="bi bi-pencil-square fa-lg m-1" />
                        </button>

                        <button
                          className="btn btn-secondary ms-2"
                          onClick={() => deleteMovement(item.idMovement, item.userName, item.lineName, item.palmName)}
                        >
                          <i className="bi bi-trash fa-lg m-1" />
                        </button>

                      </td>
                    </tr>
                  )
                }


                )}
              </tbody>
            </table>
          </div>
        </div>
      </Spin>






      <Modal
        title={`MODIFICAR REGISTRO DE LA LINEA:  ${lineName} PALMA: ${palmName}`}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="40%"
      >

        <div className="row">

          <div className="col-12 col-sm-6 ">
            <div className="card p-3  bg-light " style={{ height: "280px" }}>
              <p><strong>Línea:{lineName}  - Palma: {palmName}</strong></p>
              <div className=" col-12">
                <label className="text-secondary fw-bold">Primera </label>
                <input
                  type="number"
                  className="form-control"
                  {...register("new_first")}
                />
              </div>
              <div className=" col-12">
                <label className="text-secondary fw-bold">Segunda </label>
                <input
                  type="number"
                  className="form-control"
                  {...register("new_second")}
                />
              </div>
              <div className=" col-12">
                <label className="text-secondary fw-bold">Tercera </label>
                <input
                  type="number"
                  className="form-control"
                  {...register("new_third")}
                />
              </div>


              <div className=" col-12 mt-3">

                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => updateQuantities()}
                >
                  <i className="bi bi-calculator fa-lg m-2" /> Actualizar cantidades
                </button>

              </div>



            </div>

          </div>




          <div className="col-12 col-sm-6">
            <div className="card p-3 bg-light " style={{ height: "280px" }}>

              <form>

                <div className=" col-12 ">
                  <label className="text-secondary fw-bold">NUEVA LÍNEA</label>
                  <input
                    type="number"
                    className="form-control"
                    {...register("new_line")}
                  />
                </div>


                <div className=" col-12 mt-2">
                  <label className="text-secondary fw-bold">NUEVA PALMA</label>
                  <input
                    type="number"
                    className="form-control"
                    {...register("new_palm")}
                  />
                </div>


                <div className=" col-12">
                  <label className="text-secondary fw-bold">&nbsp;</label>
                  <br />
                  <Spin spinning={loadingSave}>
                    <button
                      className="btn btn-primary w-100"
                      type="button"
                      onClick={() => saveChanges()}
                    >
                      <i className="bi bi-tree fa-lg m-2" /> Actualizar palma
                    </button>
                    <hr></hr>

                    <button
                      className="btn btn-success w-100"
                      type="button"
                       style={{height:'45px'}} 
                      onClick={() => saveAllLine()}
                    >
                      <i className="bi bi-pencil-square fa-lg m-2"/> Actualizar toda la linea
                    </button>

                  </Spin>
                </div>



              </form>


            </div>
          </div>


        </div>


      </Modal>

    </div>
  );
};


export default UpdateRecord;
